<!-- Width-limiting container -->
<div
  class="max-w-8xl @container/hero relative mx-auto"
  [class]="{
    'px-4': padded(),
    'py-20': padded(),
    'md:px-6': padded(),
  }"
>
  <!-- Page hero goes here -->
  <ng-content></ng-content>
</div>
